// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__NKZQV","list":"BalanceDue_list__1xVV3","listRow":"BalanceDue_listRow__1moA6","total":"BalanceDue_total__3laQr"};